

export default[
    {
        title:'Nest is working on promotion of NATURAL FARMING',
        image:"../images/home1.png",
    },
    {
        title:'NEST IS PROMOTING SPORTS AS MEANS FOR BRINGING GLORY TO THE NATION IN TERMS OF SPORTS ACHIEVEMENTS AT INTERNATIONAL LEVEL AND PROMOTING SPORTS ESPECIALLY FOR THE TRIBAL POPULATION OF THE NATION, BRINGING OUT THEIR FULL POTENTIAL!',
        image:"../images/home2.png",
    },
    {
        title:'PROJECT ASHWINI TRIBAL WELFARE ENVIORNMENTAL CARE',
        image:"../images/home3.png",
    },
    {
        title:'SRI NARAYAN JEE ATTENDING INTERNATIONAL TRIBAL WELFARE ENVIORNMENTAL PROGRAM',
        image:"../images/home4.png",
    },
    {
        title:'NEST IS WORKING FOR TRIBAL WELFARE',
        image:"../images/home5.png",
    },
    {
        title:'NEST IS WORKING FOR ENVIORNMENTAL CARE',
        image:"../images/home6.png",
    },
    {
        title:'NEST IS PROMOTING NATIONALISM IN YOUTH THROUGH PROMOTING DEFENCE AS CAREER!',
       
        image:"../images/home7.png",
    },
    {
        title:'NEST IS PROMOTING SPORTS AS MEANS FOR BRINGING GLORY TO THE NATION IN TERMS OF SPORTS ACHIEVEMENTS AT INTERNATIONAL LEVEL AND PROMOTING SPORTS ESPECIALLY FOR THE POPULATION OF THE NATION,BRINGING OUT THEIR FULL POTENTIAL!',
        image:"../images/home8.png",
    },
    {
        title:'SRI NARAYAN JEE WITH THE FIRST PRESIDENT OF INDIA DR.RAJENDRA PRASAD',
        image:"../images/home9.png",
    },
    {
        title:'SRI NARAYAN JEE REPRESENTING INDIA IN THE INTERNATIONAL MEET RELATED TO SOCIAL WELFARE',
        image:"../images/home10.png",
    }
]